import { Subject } from 'rxjs'

import { MessageBox } from 'app/core/message-box/models/message-box.model'
import { Injectable } from '@angular/core'

@Injectable()
export class MessageBoxService {
    message = new Subject<MessageBox>()
}
